import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './recognition-allowances.loaders';
import { recognitionAllowanceRulesKeys } from './recognition-allowances.queries';

export const useCreateRecognitionAllowanceRule = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createAllowanceRule, {
    onSuccess: () => {
      return queryClient.invalidateQueries(recognitionAllowanceRulesKeys.lists);
    },
  });
};

export const useUpdateRecognitionAllowanceRule = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateAllowanceRule, {
    onSuccess: () => {
      return queryClient.invalidateQueries(recognitionAllowanceRulesKeys.lists);
    },
  });
};

export const useRemoveRecognitionAllowanceRule = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.removeAllowanceRule, {
    onSuccess: () => {
      return queryClient.invalidateQueries(recognitionAllowanceRulesKeys.lists);
    },
  });
};

export const useExportAllowancesToXls = () => {
  return useMutation(loaders.exportAllowancesXls, {
    onSuccess: filesConverters.export,
  });
};
